import { Badge as BadgeMui } from "@mui/material";
import { type ReactNode } from "react";
import classNames from "classnames";
import "./Badge.less";

export interface BadgeProps {
  children?: ReactNode;
  badgeContent: string | number | null;
  maxQuantity?: number;
  className?: string;
  variant?: "default" | "new";
}

export const Badge = (props: BadgeProps) => {
  const { badgeContent, maxQuantity = 99, className, variant = "default", ...elementProps } = props;

  return (
    <BadgeMui
      className={classNames(`scha__badge scha__badge--${variant}`, className)}
      badgeContent={badgeContent}
      max={maxQuantity}
      {...elementProps}
    >
      {props.children}
    </BadgeMui>
  );
};
